import * as React from 'react';
import { cn } from '@/lib/utils';

export const adminSectionClassName = 'rounded-xl border border-slate-200 bg-white p-3 sm:p-4 md:p-6';
export const adminToolbarClassName = 'mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between';
export const adminToolbarActionsClassName = 'flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center sm:gap-3';
export const adminInputClassName = 'w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm sm:w-auto';
export const adminPrimaryButtonClassName = 'inline-flex w-full items-center justify-center rounded-lg bg-[#1F8F5F] px-4 py-2 text-sm font-medium text-white hover:bg-[#17754D] sm:w-auto';
export const adminTableContainerClassName = '-mx-3 overflow-x-auto border-y border-slate-200 bg-white sm:-mx-4 md:mx-0 md:rounded-lg md:border';
export const adminTableClassName = 'min-w-full w-full text-left text-sm';
export const adminTableHeadCellClassName = 'px-3 py-2.5 sm:px-4 sm:py-3';
export const adminTableCellClassName = 'px-3 py-2.5 align-top sm:px-4 sm:py-3';

export const AdminSection = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <section
      ref={ref}
      className={cn(adminSectionClassName, className)}
      {...props}
    />
  ),
);
AdminSection.displayName = 'AdminSection';

export const AdminDataTable = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(adminTableContainerClassName, className)}
      {...props}
    />
  ),
);
AdminDataTable.displayName = 'AdminDataTable';
